import { DOCUMENT_LIST_PATH, DOCUMENT_ADD_PATH, DOCUMENT_EDIT_PATH, DEFAULT_DELETE_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import { documentAction } from './actions';
import { DocumentList, documentListLoader } from './document_list';
import { Document, documentAddLoader, documentEditLoader} from './document';
import { AuthProvider } from '../../auth_provider';

const documentRoutes = [
  {
    path: DOCUMENT_LIST_PATH.slice(1),
    element: <DocumentList />,
    loader: documentListLoader,
    shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
        return AuthProvider.is_authenticated && nextUrl.pathname === DOCUMENT_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
    },
    children: [
      {
        path: `${DEFAULT_DELETE_PATH.slice(1)}:document_id`,
        element: <ActionWindow
            title="Deletar documento"
            titleOnLoading="Deletando documento"
            titleOnFail="Falha ao deletar documento"
            description="Todos os dados relacionados ao documento serão removidos"
            confirmText="Deletar documento"
            onCancelPath={DOCUMENT_LIST_PATH}
            onFailPath={DOCUMENT_LIST_PATH}
            onSuccessPath={DOCUMENT_LIST_PATH}
            submitMethod="DELETE"
        />,
        action: documentAction
      }
    ]
  },
  {
      path: DOCUMENT_ADD_PATH.slice(1),
      element: <Document key="document:add" isEdit={false} />,
      loader: documentAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: documentAction
  },
  {
      path: `${DOCUMENT_EDIT_PATH.slice(1)}:document_id`,
      element: <Document key="document:edit" isEdit={true} />,
      loader: documentEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: documentAction
  },
];

export default documentRoutes;